import { getAge } from 'features/order/hooks/values/OrderValues'
import type { CreateCustomerData } from '../schemas'

export const isKidsAccount = (data: Partial<CreateCustomerData>) =>
  (getAge(data.birthday) ?? Infinity) < 18
